import React from "react";
import { View, StyleSheet } from "react-native";
import BaseMarketingController from "./BaseMarketingController";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtTelehealthSection from "../components/telehealth/NtTelehealthSection";
import NtTelehealthOutbreakSection from "../components/telehealth/NtTelehealthOutbreakSection";
import NtTelehealthScreeningSection from "../components/telehealth/NtTelehealthScreeningSection";
import NtTelehealthFeatureSection from "../components/telehealth/NtTelehealthFeatureSection";
import NtTelehealthContactTracingSection from "../components/telehealth/NtTelehealthContactTracingSection";
import NtTelehealthServiceSection from "../components/telehealth/NtTelehealthServiceSection";
import NtTelehealthPartnerSection from "../components/telehealth/NtTelehealthPartnerSection";

class TelehealthController extends BaseMarketingController {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer style={styles.container}>
        <NtTelehealthSection />
        <NtTelehealthOutbreakSection />
        <NtTelehealthScreeningSection />
        <NtTelehealthFeatureSection />
        <NtTelehealthContactTracingSection />
        <NtTelehealthServiceSection />
        <NtTelehealthPartnerSection />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default TelehealthController;
